// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"419":"051c790f","923":"e4252f0b"}[chunkId] + ".js";
};